import { render, staticRenderFns } from "./Radar3.vue?vue&type=template&id=d9be8060&"
import script from "./Radar3.vue?vue&type=script&lang=ts&"
export * from "./Radar3.vue?vue&type=script&lang=ts&"
import style0 from "./Radar3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports